/* eslint-disable */
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { Grid, Box, styled, Container, Card, useTheme } from "@mui/material";
import KeywordHeader from "../components/Keyword-Ranking/KeywordHeader";
import { usePopup } from "../context/commonPop";
import { GET_AVG_POSITION_CHART_DATA } from "../gql/queries/googleRanking";
import PositionFilterHead from "../components/Keyword-Ranking/PositionFilterHead";
import { GetScrapyData } from "../hooks/scrapyData";
import AiForecastWidget from "../components/ai/AiForecastWidget";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 64px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "80px",
}));

function KeyWordRanking() {
  const [rankingData, setRankingData] = useState(null);
  const [dropDownValue, setDropDownValue] = useState(50);
  const [startDate, setStartDate] = useState(dayjs().subtract(6, "day"));
  const [endDate, setEndDate] = useState(dayjs());
  const [selectedKeyword, setSelectedKeyword] = useState({
    keywords: [],
    selectedProjectId: "",
  });
  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState(null);
  const { handleOpen } = usePopup();
  const theme = useTheme();
  const navigate = useNavigate();
  const [getData] = useLazyQuery(GET_AVG_POSITION_CHART_DATA, {
    fetchPolicy: "network-only",
  });
  const { scrapyData } = GetScrapyData();

  const formatLocalDate = date => (date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ") : null);

  const domain = searchParams.get("domain");
  const projectName = searchParams.get("projectName");
  const projectId = searchParams.get("projectId");

  const validateDateRange = (start, end) => {
    const dateDifference = end.diff(start, "day");
    if (dateDifference > 15) {
      handleOpen(true, "The date range cannot exceed 15 days.");
      return false;
    }
    return true;
  };

  const handleFetch = () => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);

    if (!validateDateRange(start, end)) return;

    getData({
      variables: {
        input: {
          currentPage: 1,
          lastNDays: 6,
          limitSet: dropDownValue || 50,
          projectDomain: domain,
          searchKeyword: search,
          startDate: formatLocalDate(startDate),
          endDate: formatLocalDate(endDate),
        },
      },
      onCompleted: ({ GetKeywordWithRanks }) => setRankingData(GetKeywordWithRanks),
      onError: error => {
        console.error(error);
        handleOpen(true, error.message || "Something went wrong");
      },
    });
  };

  useEffect(() => {
    setSelectedKeyword(prevState => ({
      ...prevState,
      keyword: rankingData?.rows?.map(row => row?.keywords) || [],
    }));
  }, [rankingData]);

  useEffect(() => {
    handleFetch();
  }, [dropDownValue, search]);

  useEffect(() => {
    if (scrapyData.length > 0) {
      const firstProject = scrapyData[0];
      setSelectedKeyword({
        keywords: rankingData?.rows?.map(row => row?.keywords) || [],
        selectedProjectId: firstProject.id,
      });
    }
  }, [scrapyData]);

  const handleDateRangeChange = ([newStart, newEnd]) => {
    setStartDate(newStart ? new Date(new Date(newStart).setHours(new Date(newStart).getHours() + 8)) : null);
    setEndDate(newEnd ? new Date(new Date(newEnd).setHours(new Date(newEnd).getHours() + 8)) : null);
  };

  const handleBlogGenerator = () => {
    const keywords =
      rankingData?.rows?.map(({ keywords, ...rest }) => ({
        ...rest,
        keyword: keywords,
      })) || [];

    if (keywords.length < 1) return;

    navigate(`/urlKeywords/selected-keywords?menu=headerKeywords`, {
      state: {
        selectedKeywords: keywords,
        projectId: selectedKeyword.selectedProjectId,
      },
    });
  };
  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <KeywordHeader
                setRankingData={setRankingData}
                handleFetchData={handleFetch}
                handleDateRangeChange={handleDateRangeChange}
                startDate={startDate}
                endDate={endDate}
                domain={domain}
                projectName={projectName}
                rankingData={rankingData}
                projectId={projectId}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <Card
                sx={{
                  padding: "16px 24px 24px 24px",
                  border: `1px solid ${theme.palette.divider}`,
                  boxShadow: "none !important",
                }}
              >
                <PositionFilterHead
                  rankingData={rankingData}
                  dropDownValue={dropDownValue}
                  setDropDownValue={setDropDownValue}
                  search={search}
                  setSearch={setSearch}
                  filterPercentage={rankingData?.rankPercentages && Object.values(rankingData?.rankPercentages)}
                  filterCount={rankingData?.rankCounts && Object.values(rankingData?.rankCounts)}
                  handleBlogGenerator={handleBlogGenerator}
                  domain={domain}
                  disabled={rankingData?.rows?.length < 1}
                />
              </Card>
            </Grid>
          </Grid>
          {projectId && (
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12}>
                <AiForecastWidget projectId={projectId} />
              </Grid>
            </Grid>
          )}
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default KeyWordRanking;
